export default "__VITE_ASSET__BTXhnrl7__"